module.exports = __webpack_public_path__ + "static/media/alumni-logo.754c05a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Inc/alumni-logo.png
// module id = 1345
// module chunks = 0